import { Link } from "@mui/material";
import { MouseEvent } from "react";
import useInterfaceConfigV2 from "@hooks/useInterfaceConfigV2";

interface Props {
  /** Texto del enlace a los términos, ej. "términos y condiciones". */
  termsLabel?: string;
  /** Lo que une los dos enlaces, ej. "y el". */
  connector?: string;
  /** Cómo se nombra el aviso en la frase, ej. "política de privacidad". */
  privacyLabel?: string;
}

/** Abre en otra pestaña para no perder la solicitud; no activa el check si está dentro de su label. */
const stopPropagation = (event: MouseEvent) => event.stopPropagation();

/**
 * "términos y aviso de privacidad" con los dos enlaces a las URLs de la marca (`url_terms_and_conditions` /
 * `url_privacy_notice` de la config); sin ellas, las páginas de Lendia. Se coloca dentro de cualquier texto:
 * `Al continuar aceptas nuestros <LinkTerminosPrivacidad />.`
 */
export const LinkTerminosPrivacidad = ({
  termsLabel = "términos",
  connector = "y",
  privacyLabel = "aviso de privacidad",
}: Props) => {
  const interfaceConfig = useInterfaceConfigV2();
  const termsUrl = interfaceConfig?.url_terms_and_conditions || "/terminos_y_condiciones";
  const privacyUrl = interfaceConfig?.url_privacy_notice || "/aviso_de_privacidad";

  return (
    <>
      <Link
        href={termsUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={stopPropagation}
        color="primary.main"
        data-testid="link-terminos"
      >
        {termsLabel}
      </Link>{" "}
      {connector}{" "}
      <Link
        href={privacyUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={stopPropagation}
        color="primary.main"
        data-testid="link-aviso-privacidad"
      >
        {privacyLabel}
      </Link>
    </>
  );
};
